import styled from "styled-components";
import { useSelector } from "react-redux";

import { AccountType } from "shared/types/accounts";
import { Modal } from "@/components/modal/modal";

import { onSubmit } from "./add-password.model";
import { selectAddPasswordState } from "../../redux-model";

import { AddPasswordForm } from "../add-password-form";
import { WaitForReview } from "../wait-for-review";
import { NotApproved } from "../not-approved";

export function AddPasswordDialog({
  account,
  show,
  onHide,
  hasInbox = true,
}: {
  account: AccountType;
  show: boolean;
  onHide(): void;
  hasInbox?: boolean;
}) {
  const form = useSelector(selectAddPasswordState);

  return (
    <StyledModal show={show} onHide={onHide}>
      <Modal.Header closeButton onHide={onHide}>
        <Modal.Title>Instagram Posting connection</Modal.Title>
      </Modal.Header>
      {(() => {
        switch (form.uiState) {
          case "form": {
            return (
              <AddPasswordForm
                account={account}
                submit={onSubmit}
                {...form}
                hasInbox={hasInbox}
              />
            );
          }
          case "polling": {
            return <WaitForReview />;
          }
          case "not-approved": {
            return <NotApproved onClose={onHide} />;
          }
        }
      })()}
    </StyledModal>
  );
}

const StyledModal = styled(Modal)`
  max-width: 550px;
`;
